import React from 'react';
import style from '../css/HeaderBar.module.css';
import { Link } from 'react-router-dom';

function HeaderBar({ text, icon, navi }) {
	return (
		<div className={style.headerBar}>
			<p className={style.text}>{text}</p>

			<Link to={navi} className={style.link}>
				{icon}
			</Link>
		</div>
	);
}

export default HeaderBar;
